import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import { Box, Grid, IconButton, ListItemButton, ListItemIcon, Modal, ListItemText, Paper, Typography, useMediaQuery, Button, Menu, MenuItem, Drawer } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Image from '../../Assets/assetHelper';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import KenColors from '../../Helpers/Themes/kenColors';
import { ReactChildren } from '../../interfaces/Common';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import SideNavTabs from './Tabs';
import { useStyles } from './styles';
import routes from '../../Utils/routes';
import MobileNavTabs from './MobileTabs';
import NotificationModal from './NoficationModal';
import CalendarIcon from '../../Assets/icons_calendar.svg';
import SettingIcon from '../../Assets/icons_settings.svg';
import NotificationIcon from '../../Assets/icons_notification.svg';
import { getBasicProfileSetting } from '../../Utils/apiService';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import TimeTracker from '../../TimeTracker/TimeTracker';
import Configurl from '../../Configurl';
import Ken42logo from '../../Assets/placement/logo.png';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openNotification, setOpenNotification] = useState(false);
  const [activeIconIndex, setActiveIconIndex] = useState<number | null>(null);
  const [profileUrl, setProfileUrl] = useState('');
  const [profileName, setProfileName] = useState('');
  const handleClickIcon = (index: number) => {
    setActiveIconIndex(index === activeIconIndex ? null : index);
  };

  const handleOpenNotification = () => setOpenNotification(true);
  const handleCloseNotification = () => setOpenNotification(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:1025px)');
  const is1980 = useMediaQuery('(max-width:1280px)');

  const userData = user as AuthUser;

  const handleListClick = (path: string, index: number) => {
    console.log('Navigation path:', path);
    setAnchorEl(null);
    setTimeout(() => {
      navigate(path);
      if (path === '/login') {
        dispatch({ type: 'LOGOUT' });
      }
    }, 50);
  };
  // console.log('userData123', userData);

  // useEffect(() => {
  //   if (userData?.applicantId) {
  //     getBasicProfileSetting(userData.applicantId)
  //       .then((res) => {
  //         console.log('Profile data:', res);
  //         setProfileUrl(res?.accountDetails?.Profile_Picture_URL__c);
  //         setProfileName(res?.accountDetails?.Name || userData?.applicantName);
  //       })
  //       .catch((err) => {
  //         console.error('Error fetching profile:', err);
  //       });
  //   }
  // }, [userData?.applicantId]);
  console.log('innerwidth12', window.innerWidth);
  const { pathname, state } = useLocation();
  const navigateHistory = decodeURIComponent(pathname)
    .split('/')
    .filter((items) => {
      return items && items !== '';
    });

  return (
    <>
      {user?.applicantEmail && <TimeTracker userId={user.applicantId} email={user.applicantEmail} name={user.applicantName} />}
      {isMobile ? (
        <Grid container spacing={2} sx={{ height: '100vh' }}>
          <Grid item xs={12} sm={12}>
            <Paper sx={{ mt: 2, mr: 2, p: 1, height: 'auto', boxShadow: 'none !important' }}>
              <Grid item container spacing={1} xs={12} lg={12}>
                <Grid item xs={3} display={'flex'} flexDirection="column" justifyContent="center" alignItems="flex-start">
                  {navigateHistory?.length > 1 || navigateHistory?.[0] === 'PhotoAlbumUpload' ? (
                    <IconButton
                      onClick={() => navigate(-1)}
                      sx={{
                        mt: 0.5,
                        p: 0.5,
                        color: '#3061FF',
                        '&:hover': {
                          backgroundColor: 'rgba(48, 97, 255, 0.1)',
                        },
                      }}
                    >
                      <ArrowBackIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    <img alt="logo" className={classes.actionLogo} src="https://www.flame.edu.in/images/FLAME-menu-banner.svg" />
                  )}
                </Grid>
                <Grid item xs={6} display={'flex'} justifyContent="center" alignItems="center">
                  <AppBreadCrumbs />
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                  <div>
                    <Button onClick={handleClick}>
                      {profileUrl ? (
                        <img className={classes.profilImageMobileView} src={profileUrl} alt="profile" style={{ width: '40px', height: '40px', cursor: 'pointer' }} />
                      ) : (
                        <AccountCircleOutlinedIcon
                          sx={{
                            width: '40px',
                            height: '40px',
                            cursor: 'pointer',
                            color: 'grey',
                          }}
                        />
                      )}
                    </Button>

                    <Drawer
                      anchor="right"
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        sx: {
                          width: '80%',
                          maxWidth: '320px',
                          paddingTop: '16px',
                          paddingBottom: '16px',
                        },
                      }}
                    >
                      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <Box sx={{ px: 3, mb: 3 }}>
                          {profileUrl ? (
                            <img
                              src={profileUrl}
                              alt="profile"
                              style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '50%',
                              }}
                            />
                          ) : (
                            <AccountCircleOutlinedIcon
                              sx={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '50%',
                                color: 'grey',
                              }}
                            />
                          )}
                          <Typography sx={{ mt: 1, fontWeight: '500', fontSize: '16px' }}>{profileName || 'User Name'}</Typography>
                          {/* <Typography sx={{ color: '#666', fontSize: '14px', fontWeight: '400' }}>
                            {userData?.applicantId || 'User ID'}
                          </Typography> */}
                        </Box>

                        <Box
                          sx={{
                            borderBottom: '1px solid #EAEFFF',
                            width: '100%',
                            mb: 2,
                          }}
                        />

                        <Box sx={{ flex: 1, overflowY: 'auto', px: 1 }}>
                          <MobileNavTabs handleListClick={handleListClick} name="mobile" handleClose={handleClose} />
                        </Box>
                      </Box>
                    </Drawer>
                  </div>
                </Grid>
              </Grid>
            </Paper>
            <Box
              sx={{
                overflow: 'auto',
                // height: '100vh',
                width: '100vw',
                scrollbarColor: 'white',
                p: 2,
                scrollbarWidth: 'none',
              }}
            >
              {children}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={3} style={{ padding: isMobile ? '4px 4px' : '20px 0px 20px 20px', overflow: 'hidden' }} sx={{ width: '100vw', height: '100vh' }}>
          <Grid item xs={2} md={2}>
            <Paper className={classes.nav}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : '' }}>
                <div style={{ marginBottom: '10px' }}>
                  <img
                    className={classes.profilImage}
                    src={profileUrl ? profileUrl : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8oJh_Li1F9MTL485spsUw1L-cjntjj49vaCWWPZdjPoeZFH5lsCGjQlMZKwr1vNZUz6M&usqp=CAU'}
                    alt="profile"
                    style={{
                      width: isMobile ? '40px' : is1980 ? '90px' : '108px',
                      height: isMobile ? '40px' : is1980 ? '90px' : '108px',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      // border: '3px solidrgb(202, 202, 202)',
                    }}
                    onClick={() => navigate(routes.settings)}
                  />
                  <Typography className={classes.profileName}>{user?.applicantName ? (isMobile ? user.applicantName.slice(0, 2).toUpperCase() : user.applicantName) : ''}</Typography>
                </div>
                <div>
                  <SideNavTabs handleListClick={handleListClick} />
                </div>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={10} md={10} mb={'15px'} mt={'10px'}>
            <Grid container spacing={2}>
              <Box sx={{ height: '130px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ml: '20px' }}>
                <Grid item container spacing={3} xs={12} lg={12}>
                  <Grid item xs={6} sm={8} md={9} lg={9}>
                    <Paper className={classes.header} sx={{ borderRadius: '9px !important' }}>
                      <AppBreadCrumbs />
                    </Paper>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3} lg={3}>
                    <Paper className={classes.actions} sx={{ display: 'flex', alignItems: 'center' }}>
                      {/* <IconButton
                        sx={{
                          marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                          backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
                          color: activeIconIndex === 0 ? '#5981FF' : 'black',
                          '&:hover': {
                            backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
                          },
                        }}
                        disabled={true}
                        onClick={() => {
                          handleClickIcon(0);
                          navigate(routes.schedule);
                        }}
                      >
                        <img alt='' src={CalendarIcon} />
                      </IconButton> */}
                      <IconButton
                        sx={{
                          marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                          backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                          color: activeIconIndex === 1 ? '#5981FF' : 'black',
                          '&:hover': {
                            backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                          },
                        }}
                        onClick={() => {
                          handleClickIcon(1);
                          navigate(routes.settings);
                        }}
                      >
                        <img alt="" src={SettingIcon} />
                      </IconButton>
                      <IconButton
                        sx={{
                          marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                          backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                          color: activeIconIndex === 2 ? '#5981FF' : 'black',
                          '&:hover': {
                            backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                          },
                        }}
                        onClick={() => {
                          handleClickIcon(2);
                          navigate(routes.chats);
                        }}
                      >
                        <ModeCommentOutlinedIcon style={{ color: '#585a64', fontSize: '17px' }} />
                      </IconButton>
                      {/* <IconButton
                        sx={{
                          marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                          backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
                          color: activeIconIndex === 3 ? '#5981FF' : 'black',
                          '&:hover': {
                            backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
                          },
                        }}
                        disabled={true}
                        onClick={() => {
                          handleClickIcon(3);
                          handleOpenNotification();
                        }}
                      >
                        <img alt='' src={NotificationIcon} />
                      </IconButton> */}
                      <Modal open={openNotification} onClose={handleCloseNotification} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <NotificationModal handleClose={handleCloseNotification} />
                      </Modal>
                      <div style={{ width: '0.75px', height: '45px', background: '#C6C9D2' }} />
                      <img alt="logo" className={classes.actionLogo} src={Ken42logo} />
                      {/* <div style={{ textAlign: 'start' }}>
                        <Typography className={classes.actionText} style={{ textTransform: "uppercase" }}>{Configurl?.OrganizationName}</Typography>
                        <Typography className={classes.actionText}>Alumni Suite</Typography>
                      </div> */}
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  overflow: 'hidden',
                  // overflow: isMobile ? 'auto' : 'hidden',
                  // height: '100vh',
                  // width: '100vw',
                  height: `calc(100vh - 172px)`,
                  width: `calc(100vw - 30px)`,
                  scrollbarColor: 'white',
                  marginTop: '3px',
                  marginLeft: '20px',
                  scrollbarWidth: 'none',
                  borderRadius: '12px !important',
                }}
              >
                {children}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AppLayout;
